export default {
    book: 'Book {product}',
    age_limit: 'Kun over {age} år',
    change_plan: 'Skift plan',
    upgrade_product: 'Opgrader produkt',
    upgrade: 'Opgrader',
    cancel_upgrade: 'Annuller opgradering',
    choose_product: 'Vælg {product}',
    days: '{count} dag | {count} dage',
    login_register: 'Log ind/Registrer',
    current: 'Nuværende',
    keyless_benefits: {
        label: 'Direkte til bilen {0}',
        highlight: 'udlejningstjeneste™',
        list: {
            cant_lose_the_key: 'Fuldt forsikret',
            zero_excess: 'Ingen selvrisiko',
            phone_as_a_key: 'Telefon som nøgle',
            straight_to_car: 'Ingen ventetid',
            no_queues: 'Ingen køer',
            online_id_check: 'Online ID-tjek',
            self_checkout: 'Selv check-out',
        },
    },
};
